define('plugins/musicfavourite/nls/artist/button',{
    'en-gb': {
        'standard': {
            'addToFavourites'       : 'Add {{title}} to My Music',
            'adding'                : 'Adding',
            'addedToFavourites'     : '{{title}} Added to My Music',
            'removeFromFavourites'  : 'Remove',
            'removeFromFavouritesFullText' : 'Remove {{title}} from My Music',
            'removing'              : 'Removing'
        },
        'medium': {
            'addToFavourites'       : 'Add',
            'adding'                : 'Adding',
            'addedToFavourites'     : 'Added',
            'removeFromFavourites'  : 'Remove',
            'removing'              : 'Removing'
        }
    },
    'cy-gb': { //WELSH
        'standard': {
            'addToFavourites'       : 'Fy Ngherddoriaeth',
            'adding'                : 'Yn ychwanegu',
            'addedToFavourites'     : 'Fy Ngherddoriaeth',
            'removeFromFavourites'  : 'Dileu',
            'removeFromFavouritesFullText' : 'Dileu {{title}} o Fy Ngherddoriaeth',
            'removing'              : 'Yn dileu'
        },
        'medium': {
            'addToFavourites'       : 'Ychwanegu',
            'adding'                : 'Yn ychwanegu',
            'addedToFavourites'     : 'Ychwanegwyd',
            'removeFromFavourites'  : 'Dileu',
            'removing'              : 'Yn dileu'
        }
    },
    'ga-gb': { //IRISH
        'standard': {
            'addToFavourites'       : 'Cuir {{title}} le Mo Cheol',
            'adding'                : 'Ag cur leis',
            'addedToFavourites'     : '{{title}} Curtha le Mo Cheol',
            'removeFromFavourites'  : 'Bain',
            'removeFromFavouritesFullText' : 'Bain {{title}} &oacute; Mo Cheol',
            'removing'              : '&Aacute; baint'
        },
        'medium': {
            'addToFavourites'       : 'Cuir leis',
            'adding'                : 'Ag cur leis',
            'addedToFavourites'     : 'Curtha leis',
            'removeFromFavourites'  : 'Bain',
            'removing'              : '&Aacute; baint'
        }
    },
    'gd-gb': { //SCOTTISH
        'standard': {
            'addToFavourites'       : 'Cuir {{title}} ri Mo Che&ograve;l',
            'adding'                : 'A\' cur ris',
            'addedToFavourites'     : '{{title}} Air a chur ri Mo Che&ograve;l',
            'removeFromFavourites'  : 'Thoir &agrave;s',
            'removeFromFavouritesFullText' : 'Thoir {{title}} &agrave Mo Che&ograve;l',
            'removing'              : 'A\' toirt &agrave;s'
        },
        'medium': {
            'addToFavourites'       : 'Cuir ris',
            'adding'                : 'A\' cur ris',
            'addedToFavourites'     : 'Air a chur ris',
            'removeFromFavourites'  : 'Thoir &agrave;s',
            'removing'              : 'A\' toirt &agrave;s'
        }
    }
});

